export class Link {
  name: string
  path: string

  constructor (name: string, path: string) {
    this.name = name
    this.path = path
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/client/link.ts